<template>
   <div class="intel">

      <ViewCard v-for="(value,index) in data" :key="index" :data="value" :title="value.title" tipo="INTEL" />
   </div>
</template>

<script>
   import ViewCard from "../components/ViewCard";
   import {mapState, mapMutations, mapActions} from 'vuex'

   export default {
      name: "Intel",
      components: {ViewCard},
       computed: mapState([
           'data',
       ]),
   }
</script>

<style scoped lang="scss">
   @import "../style/base";



</style>